import { render } from "./YoutubeSearch.vue?vue&type=template&id=8a62ae02&scoped=true"
const script = {}

import "./YoutubeSearch.vue?vue&type=style&index=0&id=8a62ae02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a62ae02"]])

export default __exports__